(() => {
  if (customElements.get('announcement-carousel')) return;

  class AnnouncementCarousel extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.items = [...this.querySelectorAll('[data-announcement-item]')];
      this.index = Math.max(0, this.items.findIndex(item => item.classList.contains('is-active')));
      this.interval = Math.max(3000, Number(this.dataset.announcementInterval) || 5000);
      this.abort = new AbortController();
      this.events = { signal: this.abort.signal };

      this.items.forEach((item, index) => this.setItemState(item, index === this.index));
      if (this.items.length < 2) return;

      this.addEventListener('pointerenter', () => this.stop(), this.events);
      this.addEventListener('pointerleave', () => this.start(), this.events);
      this.addEventListener('focusin', () => this.stop(), this.events);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.start();
      }, this.events);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      }, this.events);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.started = false;
    }

    setItemState(item, active) {
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', String(!active));
      item.inert = !active;
    }

    showNext() {
      this.setItemState(this.items[this.index], false);
      this.index = (this.index + 1) % this.items.length;
      this.setItemState(this.items[this.index], true);
    }

    start() {
      if (this.timer || document.hidden || this.items.length < 2) return;
      this.timer = window.setInterval(() => this.showNext(), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = 0;
    }
  }

  customElements.define('announcement-carousel', AnnouncementCarousel);
})();
